// client/src/features/quote-builder/QuoteCalculationsDisplay.js
import React from 'react';

function QuoteCalculationsDisplay({ totals }) {
  return (
    <div className="max-w-md ml-auto space-y-3 text-lg">
      <div className="flex justify-between items-center">
        <span className="text-gray-700">Subtotal:</span>
        <span className="font-semibold text-gray-900">${totals.subtotal}</span>
      </div>
      <div className="flex justify-between items-center">
        <span className="text-gray-700">Taxable Subtotal:</span>
        <span className="text-gray-900">${totals.taxableSubtotal}</span>
      </div>
      <div className="flex justify-between items-center text-primary-700 font-medium">
        <span>Calculated Tax:</span>
        <span>${totals.calculatedTaxAmount}</span>
      </div>
      <div className="flex justify-between items-center text-red-600 font-medium">
        <span>Discount Amount:</span>
        <span>-${totals.calculatedDiscountAmount}</span>
      </div>
      <div className="flex justify-between items-center pt-4 border-t border-gray-200">
        <span className="text-2xl font-bold text-gray-800">Grand Total:</span>
        <span className="text-3xl font-extrabold text-primary-700">${totals.grandTotal}</span>
      </div>
    </div>
  );
}

export default QuoteCalculationsDisplay;
